import React, { useState, useContext } from 'react';
import {
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  Stack
} from '@mui/material';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import RoleContext from '../auth/RoleContext';
import { ROLES } from '../auth/constants';
import CacheContext from '../cache/CacheContext';
import Cache from '../cache/Cache';

export const RoleImpersonatorToggle = () => {
  const roleContext = useContext(RoleContext); // The role context
  const [anchorEl, setAnchorEl] = useState(null);

  const cacheContext = useContext(CacheContext);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearCache = () => {
    cacheContext.removeAll();
    Cache.removeAll();
  };

  const handleImpersonate = (role) => {
    clearCache();
    roleContext.impersonate(role); // Call the impersonate function with the role
    handleClose(); // Close the popover
  };

  const open = Boolean(anchorEl);
  const id = open ? 'role-impersonator-popover' : undefined;

  const availableRoles = Object.values(ROLES); // Assuming ROLES is an object with role data

  return (
    <>
      {/* The button in your control bar */}
      <IconButton
        sx={{ color: 'black' }}
        aria-describedby={id}
        onClick={handleOpen}
        size="small"
      >
        <TheaterComedyIcon sx={{ color: 'black' }} />
      </IconButton>

      {/* The flyout menu */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Stack spacing={1} sx={{ p: 2, minWidth: 220 }}>
          <Typography variant="subtitle1" gutterBottom>
            Role Impersonation
          </Typography>
          <Divider />
          <List>
            {availableRoles.map((role) => (
              <ListItem
                button
                key={role.id} // Assuming roles have unique IDs
                onClick={() => handleImpersonate(role)}
              >
                <ListItemText primary={role.name} />
              </ListItem>
            ))}
          </List>
        </Stack>
      </Popover>
    </>
  );
};